/** Empty / invalid number inputs persist as `fallback` (0 for unlimited caps). */
export function parseNumericConfigInput(raw: string, fallback = 0): number {
  const n = parseInt(raw, 10);
  return Number.isFinite(n) ? n : fallback;
}
